import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'alquiler'

const AlquilerRepository = {
  crearActualizarAlquiler(idFichaAgricola, cantidad, importeTotal, comentario) {
    let data = {
      idFichaAgricola,
      cantidad,
      importeTotal,
      comentario
    }
    return ApiService.post(`${REPOSITORY_URL}/crear_actualizar_alquiler`, data)
  },

  listaAlquiler(idFichaAgricola) {
    let data = {
      idFichaAgricola
    }
    return ApiService.get(`${REPOSITORY_URL}/lista_alquiler`, data)
  },

  borrarAlquiler(idFichaAgricola) {
    let data = {
      idFichaAgricola
    }
    return ApiService.post(`${REPOSITORY_URL}/borrar_alquiler`, data)
  },
}

export default AlquilerRepository
